import React from "react";
import GameContainer from "../../../../../edu_lms/components/Game";
import DragAndDropBackGroundTvContainer from "../../../../../edu_lms/components/Game/DragAndDropBackGroundTv/DragAndDropBackGroundTvContainer";

const DAD_BG_TV = ({ activity, bookId, showResult }) => {
	return (
		<GameContainer data={activity}>
			<DragAndDropBackGroundTvContainer data={activity} objectId={bookId} showResult={showResult}/>
		</GameContainer>
	);
};

export default DAD_BG_TV;
